import React, { useState, useEffect } from 'react'
import './termination.css'
import { Link } from 'react-router-dom'
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import { useForm, Controller } from 'react-hook-form';
import profile from '../../../assets/profile.png'
import { useDispatch, useSelector } from 'react-redux'
import {fetchTerminations, submitTermination, updateTermination} from '../../../api/termApi'
import {handleOpenModal, handleCloseModal} from '../../../state/modalSlice'
import moment from 'moment';
import {getAllUsers} from '../../../api'
import {handleStaffs} from '../../../state/userSlice'
import {handleTermination} from '../../../state/termSlice'
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import Loader from '../../../components/loader/Loader'
import ActionCell from '../../../components/actionCell/ActionCell'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content';

// Create a SweetAlert2 instance with React integration
const MySwal = withReactContent(Swal);



function ExpandableCell({ value }) {
    const [expanded, setExpanded] = useState(false);
  
    return (
        <div style={{display: 'flex',flexDirection: 'column'}}>
            <div dangerouslySetInnerHTML={{__html: expanded ? value 
                : (value?.length > 70 ? value?.slice(0, 70)+'...' 
                : value?.slice(0, 70))}}>
            </div>
            {value?.length > 100 && (
            <button
                className="request__status-table_btn"
                type="button"
                onClick={() => setExpanded(!expanded)}
            >
                {expanded ? 'view less' : 'view more'}
            </button>
            )}
        </div>
    );
}

const columns = [
    {
        field: 'name',
        headerName: 'Name',
        width: 250,
        renderCell: (param)=>{
            return (
                <div className='termination__table-profile'>
                    <img src={param.row.img} 
                    alt="" className="termination__table-img" />
                    <div className="termination__table-profile_list">
                        <h4 className="termination__table-profile_name">
                            {param?.row?.user?.firstName + ' ' + param?.row?.user?.lastName}
                        </h4>
                        <span className="termination__table-profile_email">
                            {param?.row?.user?.lastName}
                        </span>
                    </div>
                </div>
            )
        }
    },
    {
        field: 'department',
        headerName: 'Department',
        width: 150,
        renderCell: (param) => (
            <span>{param?.row?.user?.department}</span>
        )
    },
    {
        field: 'type',
        headerName: 'Termination type',
        width: 150,
    },
    {
        field: 'reason',
        headerName: 'Reason',
        width: 170,
        renderCell: (param) => <ExpandableCell value={param?.row?.reasons} />
    },
    {
        field: 'terminationDate',
        headerName: 'Termination Date',
        width: 140,
        renderCell: (param) => (
            <span>{moment(param?.row?.terminationDate).format('DD MMMM YYYY')}</span>
        )
    },
    {
        field: 'noticeDate',
        headerName: 'Notice Date',
        width: 130,
        renderCell: (param) => (
            <span>{moment(param?.row?.noticeDate).format('DD MMMM YYYY')}</span>
        )
    },
    {
        field: 'action',
        headerName: 'Action',
        width: 90,
        renderCell: (param) => <ActionCell param={param} />
    },
];


const AddTermination = ({user, closeModal, staffs, modal, handleGetTerms}) => {
    const [isLoading, setIsLoading] = useState(false)
    const {
        register,
        handleSubmit,
        formState:{errors},
        reset,
        getValues,
        control,
    } = useForm({
        mode: 'onChange',
        defaultValues: modal?.data ? {...modal?.data} : ''
    })

    const onSubmit = async (data) =>{
        setIsLoading(true)
        try{
            const res = await modal?.data 
            ? updateTermination(user?.token, data, modal?.data?._id) 
            : submitTermination(user?.token, data)
            if(res?.success){
                MySwal.fire({
                    icon: 'success',
                    title: res?.message,
                    showConfirmButton: false,
                    timer: 2000
                });
                reset()
                handleGetTerms()
                closeModal()
            }else{
                MySwal.fire({
                    icon: 'error',
                    title: res?.message,
                    showConfirmButton: false,
                    timer: 2000
                });
            }
            setIsLoading(false)
        }catch(error){
            console.log(error)
            setIsLoading(false)
            MySwal.fire({
                icon: 'error',
                title: "There's an error processing your request, Try again",
                showConfirmButton: false,
                timer: 2000
            });
        }
    }

    return (
        <div className="modal" onClick={closeModal}>
            <div className="modal-content" onClick={(e)=>e.stopPropagation()}>
                <div className="modal-heading">
                    <h4 className="modal-title">Add Termination</h4>
                    <button type='button' onClick={closeModal}
                    className="modal-btn">
                        <i class='bx bx-x'></i>
                    </button>
                </div>
                <form className="modal-form" onSubmit={handleSubmit(onSubmit)}>
                    <div className="modal-field">
                        <label htmlFor="staff" className='modal-label'>
                            Staff <span>*</span>
                        </label>
                        <select name="staff" className="modal-input"
                        {...register('staff',{required: 'This field is required'})}>
                            <option value="" disabled>Select a staff</option>
                            {
                                staffs?.map((item, i)=>(
                                    <option value={item?._id} key={i}>
                                        {item?.firstName + ' ' + item?.lastName}
                                    </option>
                                ))
                            }
                        </select>
                        {errors?.staff && (
                            <span className="modal-error">{errors?.staff?.message}</span>
                        )}
                    </div>
                    <div className="modal-field">
                        <label htmlFor="type" className='modal-label'>
                            Termination Type <span>*</span>
                        </label>
                        <select name="type" className="modal-input"
                        {...register('type',{required: 'This field is required'})}>
                            <option value="" disabled>Select a staff</option>
                            <option value="Misconduct">Misconduct</option>
                            <option value="Dismissal">Dismissal</option>
                            <option value="Redundancy">Redundancy</option>
                            <option value="Retirement">Retirement</option>
                            <option value="Health Reasons">Health Reasons</option>
                            <option value="Theft">Theft</option>
                        </select>
                        {errors?.type && (
                            <span className="modal-error">{errors?.type?.message}</span>
                        )}
                    </div>
                    <div className="modal-items">
                        <div className="modal-field">
                            <label htmlFor="noticeDate" className='modal-label'>
                                Notice Date <span>*</span>
                            </label>
                            <input type="date" name='noticeDate' className="modal-input" 
                            {...register('noticeDate',{required: 'This field is required'})}/>
                            {errors?.noticeDate && (
                                <span className="modal-error">{errors?.noticeDate?.message}</span>
                            )}
                        </div>
                        <div className="modal-field">
                            <label htmlFor="terminationDate" className='modal-label'>
                                Termination Date <span>*</span>
                            </label>
                            <input type="date" name='terminationDate' className="modal-input" 
                            {...register('terminationDate',{required: 'This field is required'})}/>
                            {errors?.terminationDate && (
                                <span className="modal-error">{errors?.terminationDate?.message}</span>
                            )}
                        </div>
                    </div>
                    <div className="modal-field">
                        <label htmlFor="reasons" className='modal-label'>
                            Reason <span>*</span>
                        </label>
                        <Controller
                            name="reasons"
                            control={control}
                            defaultValue=""
                            rules={{required: 'This field is required'}}
                            render={({ field }) => (
                            <ReactQuill
                                name="reasons"
                                theme="snow"
                                value={field.value}
                                onChange={(content) => field.onChange(content)}
                            />
                            )}
                        />
                        {errors?.reasons && (
                            <span className="modal-error">{errors?.reasons?.message}</span>
                        )}
                    </div>
                    <div className="modal-field bottom">
                        {
                            isLoading ? <Loader/> : <button type='submit'
                            className='modal-button button'>
                                Submit
                            </button>
                        }
                    </div>
                </form>

            </div>
        </div>
    )
}

const Termination = () => {
    const {user, staffs} = useSelector((state)=>state.user)
    const {termination} = useSelector((state)=>state.termination)
    const {modal} = useSelector((state)=>state.modal)
    const [value, setValue] = useState('')
    const dispatch = useDispatch()

    const openModal = () =>{
        dispatch(handleOpenModal())
    }
    const closeModal = () =>{
        dispatch(handleCloseModal())
    }

    const handleFetchUsers = async () => {
        try{
            const res = await getAllUsers(user?.token)
            dispatch(handleStaffs(res?.data))
        }catch(error){
            console.log(error)
        }
    }

    const handleGetTerms = async () =>{
        try{
            const res = await fetchTerminations(user?.token)
            dispatch(handleTermination(res?.data))
        }catch(error){
            console.log(error)
        }
    }

    useEffect(()=>{
        handleGetTerms()
        handleFetchUsers()
    },[])

    const filterItems = termination?.filter((item)=>{
        return item?.user?.firstName?.toLowerCase().includes(value.toLowerCase())
        || item?.user?.lastName?.toLowerCase().includes(value.toLowerCase())
        || item?.user?.email?.toLowerCase().includes(value.toLowerCase())
    })


  return (
    <section className='termination'>
        {/* HEADING */}
        <div className="heading">
            <div className="heading__box">
                <div className="heading-item">
                    <h3 className="heading-title">Terminations | </h3>
                    <i class='bx bx-home heading__title-icon'></i>
                    <Link to="/" className="heading-text">
                        Home <i class='bx bx-chevron-right heading-icon'></i>
                    </Link>
                    <span className="heading-text">
                        Terminations <i class='bx bx-chevron-right heading-icon'></i>
                    </span>
                </div>
                <p className="heading-text">
                    View Terminationss
                </p>
            </div>
            <button 
            onClick={openModal}
            className="heading__box-btn button">
                Add Termination
            </button>
        </div>

        <div className="termination__container">
            <div className="termination__search">
                <h4 className="termination__search-title">Terminations</h4>
                <div className="termination__search-box">
                    <span className="termination__search-span">Search:</span>
                    <input type="text" placeholder="Name or email..."
                    value={value} onChange={(e)=>setValue(e.target.value)}
                    className='termination__search-input'/>
                </div>
            </div> 

            <div className="termination__table">
                <DataGrid
                    getRowId={(rows => rows?._id)}
                    rows={filterItems ?? []}
                    columns={columns}
                    initialState={{
                    pagination: {
                        paginationModel: {
                        pageSize: 5,
                        },
                    },
                    }}
                    pageSizeOptions={[5]}
                    checkboxSelection
                    disableRowSelectionOnClick
                    getRowHeight={() => 'auto'} 
                    sx={{
                        '&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell': {
                            py: 0.5,
                        },
                        '&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell': {
                            py: '5px',
                        },
                        '&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell': {
                            py: '10px',
                        },
                    }}
                    experimentalFeatures={{ lazyLoading: true }}
                />
            </div>
        </div>
        {modal?.show && <AddTermination 
        user={user}
        modal={modal}
        closeModal={closeModal} 
        staffs={staffs}
        handleGetTerms={handleGetTerms}/>}
    </section>
  )
}

export default Termination